import { Login } from '@/routes';
import Home from '@/routes/Home';
import { connect } from 'react-redux';
import { getUserEmail } from '@/redux/user/selectors';

type LandingProps = {
  onLogin: () => void;
  email: string;
};

const Landing = ({ email, onLogin }: LandingProps) =>
  email ? <Home /> : <Login onLogin={onLogin} />;

const mapStateToProps = (state: never) => ({
  email: getUserEmail(state)
});

export default connect(mapStateToProps)(Landing);
